class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    
    this.element = this

    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || document.querySelector('.template-cart cart-items');
      const bundleId = this.dataset.bundleId;
      this.checkHasAttribute = element => element.hasAttribute(`data-product-no-free-sample`);
      this.cartItemsProducts = this.cartItems.querySelectorAll('.cart-item');
      this.cartItemsProductsArray = Array.from(this.cartItemsProducts);
      this.countProductNotSample = this.cartItemsProductsArray.filter(this.checkHasAttribute).length

      if(this.countProductNotSample > 1) {
      

      if (bundleId) {
        // if product is a Container for bundle, remove all bundle's products
        const update = {}
        const bundleItems = document.querySelectorAll(`[data-bundle-id="${bundleId}"]`)

        bundleItems.forEach(button => {
          update[button.dataset.key] = 0;
        })

        this.removeBundleItems(update)

      } else {
        this.cartItems.updateQuantity(this.dataset.index, 0);
      }

      } else {
        this.clearCart();
      }



      //------------------ Manage the cart empty --------------------//
      const cartItemsNumber = this.closest('cart-items') || document.querySelector('.template-cart cart-items');


      if (cartItemsNumber) {
        // Nombre d'éléments <li> avec la classe 'cart-item'
        const nombreItemsCart = cartItemsNumber.querySelectorAll('li.cart-item').length;

        if (nombreItemsCart <= 1) {
          var emptyContainer = document.querySelector('main.cart');
          emptyContainer.classList.add('is-empty');
        }
      }


      this.addDatalayerRemoveToCart(this.element)

    });
  }

  clearCart() {
    const body = JSON.stringify({
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((state) => {
      let emptyContainer = document.querySelector('main.cart');
      if (emptyContainer) {
        emptyContainer.classList.add('is-empty');
      }
      this.updateCartState(state);
    })
    .catch(() => {

      this.catchCart();
    });
  }

  removeBundleItems(updates){
    const body = JSON.stringify({
      updates,
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: body,
    })
    .then(response => {
      return response.json();
    })
    .then((state) => {
      this.updateCartState(state);
      
     
    }).catch(() => {
      this.catchCart();
    });
  }

  updateCartState(state) {
    const parsedState = state;
    this.cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.cartItems.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    this.cartItems.updateLiveRegions(line, parsedState.item_count);
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {

      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
    }
    this.cartItems.disableLoading();
  }

  catchCart() {
  this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

    errors.textContent = window.cartStrings.error;
    errors.classList.add('is-error', 'u-mb-15', 't-text', 't-text--12')
    setTimeout(() => {
      errors.classList.add('u-hidden')
    }, 5000);
    this.cartItems.disableLoading();
  }

  addDatalayerRemoveToCart(element) {
    this.totalPriceCart = element.dataset.totalPriceCart;
    this.productTitle = element.dataset.productTitle;
    this.productId = element.dataset.productId;
    this.productPrice = element.dataset.productPrice;
    this.productOldPrice = element.dataset.productCompareAtPrice;
    this.productCoupon = element.dataset.productCoupon;
    this.productDiscount = element.dataset.productDiscount;
    this.productIndex = element.dataset.index;
    this.itemCat = element.dataset.itemCategory;
    this.itemCat2 = element.dataset.itemCategory2;
    this.itemListId = element.dataset.itemListId;
    this.itemListName = element.dataset.itemListName;
    this.productQuantity = element.dataset.productQuantity;
    this.locationId = element.dataset.locationId;
    this.actualQuantity = element.dataset.selectActualQuantity



    const dataLayerClear = {
      ecommerce: null
    };
    window.dataLayer.push(dataLayerClear);

    const dataLayerRemoveFromCart = {
      event: 'remove_from_cart',
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: Number(this.productPrice * this.actualQuantity || this.productPrice),
        items: [{
          item_name: String(this.productTitle),
          item_id: String(this.productId),
          coupon: null,
          discount: Number(this.productDiscount),
          index: Number(this.productIndex || undefined),
          item_category: String(this.itemCat),
          item_category2: String(this.itemCat2),
          item_list_id: Number(this.itemListId || undefined),
          item_list_name: String(this.itemListName || undefined),
          location_id: String(this.locationId || undefined),
          price: Number(this.productPrice),
          quantity: String(this.productQuantity),
        }, ],
      },
    };
    window.dataLayer.push(dataLayerRemoveFromCart);

  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
     if(!event.target.classList.contains('t-checkbox')) {
       this.onChange(event);
     }
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
     // if element if child of <cart-free-item>, this element do not need update here
    const isChildFreeItem = event.target.parentNode.classList.contains('cart-free-item')
    if(isChildFreeItem) return;
    
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }


  getSectionsToRender() {
    return [{
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'announcement-bar',
        section: document.getElementById('announcement-bar')?.dataset.id,
        selector: '.js-contents-announcement',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {

          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

        errors.textContent = window.cartStrings.error;
        errors.classList.add('is-error', 'u-mb-15', 't-text', 't-text--12')
        setTimeout(() => {
          errors.classList.add('u-hidden')
        }, 5000);
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {

      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    } else {

      lineItemError.classList.add('is-error');

    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({
          note: event.target.value
        });
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{
            body
          }
        });
      }, 300))
    }
  });
};